export default __webpack_public_path__ + "svg/calendar/2025/3/abril.svg?76b7e65c";